export * from "MWL@2026/core/types/NullObjects";
export {hasKey} from "MWL@2026/core/types/hasKey";
export {type Cstr} from "MWL@2026/core/types/classes";